(function () {
  'use strict';
  if (window.__loomSelectionV2) return;
  window.__loomSelectionV2 = true;
  function all(selector, root) { return Array.prototype.slice.call((root || document).querySelectorAll(selector)); }
  function money(cents) { if (window.theme && window.theme.formatMoney) return window.theme.formatMoney(cents); return '$' + (cents / 100).toFixed(2); }
  function selected(root) { return all('[data-loom-addon-toggle]', root).filter(function (input) { return input.checked && !input.disabled; }); }
  function showSlide(carousel, index) {
    var slides = all('[data-loom-slide]', carousel);
    if (!slides.length) return;
    index = (index + slides.length) % slides.length;
    carousel.dataset.loomActive = String(index);
    slides.forEach(function (slide, i) { slide.hidden = i !== index; });
    all('[data-loom-dot]', carousel).forEach(function (dot, i) { dot.classList.toggle('is-active', i === index); dot.setAttribute('aria-pressed', i === index ? 'true' : 'false'); });
  }
  function selection(product) {
    var inputs = selected(product);
    var total = inputs.reduce(function (sum, input) { return sum + Number(input.dataset.price || 0); }, 0);
    var label = product.querySelector('[data-loom-selection]');
    if (label) label.textContent = inputs.length + ' optional add-ons selected · ' + money(total) + ' added to the main product';
    all('.loom-carousel--addons', product).forEach(function (carousel) {
      var group = selected(carousel);
      var summary = carousel.querySelector('[data-loom-group-selection]');
      if (summary) summary.textContent = group.length ? group.length + ' add-ons in this group · ' + money(group.reduce(function (sum, input) { return sum + Number(input.dataset.price || 0); }, 0)) : 'No add-ons in this group selected';
    });
  }
  function setGroup(input) {
    var carousel = input.closest('.loom-carousel--addons');
    if (!carousel) return;
    var checked = input.checked;
    all('[data-loom-addon-toggle]', carousel).forEach(function (other) { other.checked = checked && !other.disabled; });
    selection(input.closest('[data-loom-product]'));
  }
  function init(root) {
    all('[data-loom-product]', root || document).forEach(function (product) {
      selection(product);
      all('[data-loom-carousel]', product).forEach(function (carousel) {
        if (carousel.dataset.loomReady) return;
        carousel.dataset.loomReady = 'true';
        showSlide(carousel, 0);
        var start = null;
        carousel.addEventListener('pointerdown', function (e) { if (e.target.closest('input,label,button')) return; start = e.clientX; });
        carousel.addEventListener('pointerup', function (e) { if (start === null) return; var distance = e.clientX - start; start = null; if (Math.abs(distance) > 45) showSlide(carousel, Number(carousel.dataset.loomActive || 0) + (distance < 0 ? 1 : -1)); });
        carousel.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); showSlide(carousel, Number(carousel.dataset.loomActive || 0) + (e.key === 'ArrowRight' ? 1 : -1)); } });
      });
    });
  }
  function request(root, endpoint, body) {
    var options = { credentials: 'same-origin', headers: { Accept: 'application/json' } };
    if (body !== undefined) { options.method = 'POST'; options.headers['Content-Type'] = 'application/json'; options.body = JSON.stringify(body); }
    return fetch(root + endpoint, options).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok || data.status) throw new Error(data.description || data.message || 'Could not update the selected products.');
        return data;
      });
    });
  }
  function syncBundle(product, mainId, mainQty, root) {
    var managed = {}; managed[String(mainId)] = true;
    all('[data-loom-addon-toggle]', product).forEach(function (input) { if (Number(input.value)) managed[String(Number(input.value))] = true; });
    var desired = {}; desired[String(mainId)] = mainQty;
    selected(product).forEach(function (input) { var id = Number(input.value); if (id && id !== mainId) desired[String(id)] = 1; });
    return request(root, 'cart.js').then(function (cart) {
      var updates = {}, present = {};
      (cart.items || []).forEach(function (line) {
        var id = String(line.variant_id);
        if (!managed[id]) return;
        // Only manage this bundle's plain lines. Preserve personalised,
        // subscription or independently tagged lines, even with the same variant.
        var properties = line.properties || {};
        if (line.selling_plan_allocation || Object.keys(properties).length) return;
        var wanted = desired[id] || 0;
        var quantity = present[id] ? 0 : wanted;
        if (wanted) present[id] = true;
        if (quantity !== line.quantity) updates[line.key] = quantity;
      });
      var missing = Object.keys(desired).filter(function (id) { return !present[id]; }).map(function (id) { return { id: Number(id), quantity: desired[id] }; });
      var update = Object.keys(updates).length ? request(root, 'cart/update.js', { updates: updates }) : Promise.resolve(cart);
      return update.then(function () { return missing.length ? request(root, 'cart/add.js', { items: missing }) : null; });
    }).then(function () { return request(root, 'cart.js'); });
  }
  document.addEventListener('click', function (e) {
    var dot = e.target.closest('[data-loom-dot]');
    if (dot) { showSlide(dot.closest('[data-loom-carousel]'), Number(dot.dataset.loomDot)); return; }
    var clear = e.target.closest('[data-loom-clear-addons]');
    if (clear) { all('[data-loom-addon-toggle]', clear.closest('[data-loom-product]')).forEach(function (input) { input.checked = false; }); selection(clear.closest('[data-loom-product]')); return; }
    var videoButton = e.target.closest('[data-loom-video]');
    if (videoButton) { var video = videoButton.parentNode.querySelector('video'); if (video.paused) { video.play().catch(function () {}); videoButton.textContent = 'Pause video'; videoButton.setAttribute('aria-label', 'Pause video'); } else { video.pause(); videoButton.textContent = 'Play video'; videoButton.setAttribute('aria-label', 'Play video'); } }
  });
  document.addEventListener('change', function (e) { if (e.target.matches('[data-loom-addon-toggle]')) setGroup(e.target); });
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-loom-form]');
    if (!form) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (form.dataset.loomBusy) return;
    var product = form.closest('[data-loom-product]');
    var button = form.querySelector('[type=submit]');
    var label = button.querySelector('[data-loom-atc-label]');
    var error = form.querySelector('[data-loom-error]');
    var mainId = Number(form.querySelector('[name=id]').value);
    var mainQty = Math.max(1, Number(form.querySelector('[name=quantity]').value || 1));
    if (!mainId) { error.textContent = 'This product is not available in the store.'; error.hidden = false; return; }
    form.dataset.loomBusy = 'true'; button.disabled = true; label.textContent = 'UPDATING…'; error.hidden = true;
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    syncBundle(product, mainId, mainQty, root).then(function (cart) {
      all('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.hidden = !cart.item_count; });
      all('[data-cart-count-text]').forEach(function (el) { el.textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' items'); });
      if (window.theme && window.theme.refreshDrawer && document.getElementById('CartDrawer')) return window.theme.refreshDrawer().then(function () { window.theme.openDrawer(); });
      window.location.assign(root + 'cart');
    }).catch(function (err) { error.textContent = err.message; error.hidden = false; }).finally(function () { delete form.dataset.loomBusy; button.disabled = false; label.textContent = 'ADD TO CART'; });
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
